export const pageHeading = "Notes from the Farm";
export const headerImg = "./images/inner-header-bg.png";
export const list = [
  {
    key: "1",
    img: "./images/turmeric-powder.png",
    date: "October 2026",
    title: "What the 4.16% on our turmeric means",
    buttonText: "Read more",
    buttonLink: "#/blogContent?name=turmeric-lab-test",
  },
];
